import { PAGE_TYPES } from '@/utils/constants';
import type { HomePageConfig } from '@/types/aggregation/home';
import { getStaticPageData } from '@/lib/aggregation';
import type { Metadata } from 'next';
import type { AbsoluteTemplateString } from 'next/dist/lib/metadata/types/metadata-types';

type ProductWithSiteWideJackpot = { data?: { site_wide_jackpot?: { enabled?: boolean } } };

/**
 * Checks if site-wide jackpot is enabled based on the `enabled` property from jackpotData.
 */
export const getIsSiteWideJackpotEnabled = (product: ProductWithSiteWideJackpot | null | undefined): boolean =>
    product?.data?.site_wide_jackpot?.enabled === true;

/**
 * Returns true when the page should redirect to 404.
 */
export const checkIfPageShouldRedirect = (pageConfig: HomePageConfig, pageType: string): boolean => {
    switch (pageType) {
        case PAGE_TYPES.SITE_WIDE_JACKPOT: {
            return !getIsSiteWideJackpotEnabled(pageConfig.pageConfig.product);
        }
        default:
            return false;
    }
};

export const getStaticPageMetadata = async (
    slug: string,
    {
        defaultTitle,
        defaultDescription
    }: { defaultTitle: AbsoluteTemplateString | null; defaultDescription: string | null }
): Promise<Metadata> => {
    const staticPage = await getStaticPageData(slug);
    const data = staticPage?.pageConfig?.content?.data;

    return {
        title: data?.seo_meta_title ?? defaultTitle,
        description: data?.seo_meta_description ?? defaultDescription
    };
};
